import * as React from "react";
import DataSource, { DATE_DISPLAY_FORMAT } from "../lib/DataSource";
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import Moment from "moment";
import { FetchWithAuth } from "digimaker-ui/util";
import { Link } from "react-router-dom";
import FormItem from "antd/lib/form/FormItem";
import Checkbox from "antd/lib/checkbox/Checkbox";

const { Option } = Select;
export default class SubjectResultAdd extends React.Component<
  { subject: any; list: any; onSuccess: any },
  { data: any; ignoreList: any; is_repeat: any; action: string }
> {
  constructor(props: any) {
    super(props);
    this.state = { data: "", ignoreList: {}, is_repeat: {}, action: "" };
  }

  componentDidMount() {
    this.fetchSubject();
  }

  fetchSubject() {
    FetchWithAuth("icd/subject/get/" + this.props.subject.id)
      .then((data) => {
        this.setState({ data: data.data.assessments });
      })
      .catch((err) => {
        this.setState(() => {
          throw err;
        });
      });
  }

  submit(values: any) {
    let assessment = values["assessment"];
    let params: Array<any> = [];
    for (let index in values["score"]) {
      const studentID = values["student"][index];
      if (studentID) {
        params.push({
          student_id: values["student"][index],
          assessment_id: assessment,
          score: parseFloat(values["score"][index]),
          is_repeat: values["is_repeat"][index],
          repeat_no: values["repeat_no"][index]
            ? parseInt(values["repeat_no"][index])
            : 0,
        });
      }
    }
    FetchWithAuth("icd/subject/result/add", {
      method: "POST",
      body: JSON.stringify(params),
    })
      .then((data) => {
        if (data.data === 1) {
          Modal.info({
            content: <p>Add successful!</p>,
            onOk: () => this.props.onSuccess(),
          });
        } else {
          Modal.error({ content: data.error.message });
        }
      })
      .catch((err) => {
        this.setState(() => {
          throw err;
        });
      });
  }

  setRepeat(index: any, checked) {
    let isRepeat = this.state.is_repeat;
    isRepeat[index] = checked;
    this.setState({ is_repeat: isRepeat });
  }

  setIgnore(index: any, checked) {
    let list = this.state.ignoreList;
    list[index] = checked;
    this.setState({ ignoreList: list });
  }

  render() {
    if (!this.state.data) {
      return <div>No assessment set up in this subject.</div>;
    }

    return (
      <div>
        <Form onFinish={(values) => this.submit(values)}>
          <h3>Add result to {this.props.subject.name}</h3>
          <Row>
            <Col span={12}>Assessment:</Col>
            <Col span={12}>
              <Form.Item
                rules={[{ required: true, message: "Please input!" }]}
                name="assessment"
              >
                <Select
                  style={{ width: "100%" }}
                  placeholder="Select assessment"
                >
                  {this.state.data.map((item: any) => (
                    <Option value={item.id}>
                      {item.assessment}({item.percentage}%)
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          {this.props.list && (
            <div>
              {this.props.list.map((item, index) => (
                <Row>
                  {!this.state.ignoreList[index] && (
                    <>
                      <Col span={6}>
                        {item.firstname} {item.lastname} <br />{" "}
                        {item.student_no}
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          style={{ display: "none" }}
                          name={["student", index]}
                          initialValue={item.id}
                        >
                          <Input type="hidden" />
                        </Form.Item>
                        <Form.Item
                          rules={[{ required: true, message: "Please input!" }]}
                          name={["score", index]}
                          label={"Score"}
                        >
                          <Input type="number" />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Form.Item
                          name={["is_repeat", index]}
                          valuePropName="checked"
                          label={"Repeat"}
                        >
                          <Checkbox
                            onChange={(e) =>
                              this.setRepeat(index, e.target.checked)
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Form.Item
                          name={["repeat_no", index]}
                          initialValue={"1"}
                        >
                          <Input
                            disabled={!this.state.is_repeat[index]}
                            type="number"
                            placeholder="No."
                          />
                        </Form.Item>
                      </Col>
                    </>
                  )}
                  {this.props.list.length > 1 && (
                    <Col span={2}>
                      <label>
                        <input
                          type="checkbox"
                          defaultChecked={false}
                          value={1}
                          onChange={(e) =>
                            this.setIgnore(index, e.target.checked)
                          }
                        />{" "}
                        Ignore
                      </label>
                    </Col>
                  )}
                </Row>
              ))}
            </div>
          )}

          <div>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
